<app-tab-header [tabs]="tabs"></app-tab-header>

<div class="category-header">
  <div class="title-wrapper">
    <h1>
      {{ selectedCategory?.name | titlecase }}
    </h1>
    <p>
      {{discoverCategory?.name | titlecase}}
    </p>
  </div>
</div>

@if(addOn){
<button class="btn btn-light eternal-banner" [style]="{backgroundImage: 'url('+addOn.bannerImageUrl+')'}"
  (click)="handleBannerClick()">{{addOn.bannerTitle}}</button>
}

<div class="header">

  <div class="title">
    {{productList.groups[0]}}
  </div>

  <div class="right-side">

    <app-only-in-stock [withPezzotto]="applyPortoRicoPezzotto"></app-only-in-stock>

    <app-item-size-selector (onChangeSize)="handleChangeSize($event)"></app-item-size-selector>

    @if(filtersService.areFiltersVisible()){

    <div class="vr"></div>

    <button class="search btn btn-rounded" [ngClass]="{
    'btn-light':!productList.searching,
     'btn-primary':productList.searching
     }" (click)="handleSearchClick()">

      @if(productList.searching){
      <i class="bi bi-sliders"></i>
      }@else {
      <i class="bi bi-sliders"></i>
      }

    </button>

    }

  </div>

</div>

<div class="products-page container-fluid">

  @for (product of productList.items;let i = $index; track product.sapCode + i) {

  @if(showTitle(i)){
  <div class="header">
    <div class="title">{{product.group}}</div>
  </div>
  }

  <div class="product-wrapper" [ngClass]="productSizeClass()">
    <app-product [product]="product"></app-product>
  </div>
  }

  @if(!loaderService.loading() && productList.isEmpty){
  <app-placeholder [message]="'No results found'|translate">
    <p>{{'Unfortunately we could not find any product matching the criteria'|translate}}</p>
  </app-placeholder>
  }

</div>

@if(filtersService.areFiltersVisible()){
<app-drawer>
  <h3 title>{{'Filters'|translate}}</h3>
  <app-filters body></app-filters>
  <div footer class="footer">
    <button class="btn btn-primary" (click)="filtersService.submit()">
      {{'Search'|translate}}
    </button>
    <button class="btn btn-light" (click)="handleReset()">
      {{'Reset filters'|translate}}
    </button>
  </div>
</app-drawer>
}

<app-attachments-modal #attachmentModal></app-attachments-modal>
